module.exports = __webpack_public_path__ + "img/feature-coach.14fe08dd.png";